import { jsx as _jsx } from "react/jsx-runtime";
import { Video } from '@streamr/tv-ui';
import { useMemo } from 'react';
export function DirectVideo({ track }) {
    const mediaStream = useMemo(() => new MediaStream([track]), [track]);
    return (_jsx(Video, { srcObject: mediaStream, autoPlay: true, playsInline: true, muted: true, fit: "contain" }));
}
